import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import { crownsList } from "../apiConfigs";

export const getCrownsListApi = createAsyncThunk(
    "auth/crowns-and-badges/getCrownsList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(crownsList);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getCrownsListSlice = createSlice({
    name: "auth/crowns-and-badges/getCrownsList",
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetgetCrownsList: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(getCrownsListApi.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getCrownsListApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
        });
        builder.addCase(getCrownsListApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});
export const { resetgetCrownsList } = getCrownsListSlice.actions;
export const getCrownsListReducer = getCrownsListSlice.reducer;
